import { get, post, put, withUrl, Request } from '../rest';


const accountPart = withUrl('account');

export const account = {
    get: get<void, string>(
        () => accountPart(),
    ),

    create: post<Request.Body, string>(
        ({ body }) => accountPart({
            path: 'create',
            body,
        }),
    ),

    put: put<Request.Body, void>(
        ({ body }) => accountPart({
            body,
        }),
    ),
};
